import Vue from 'vue'
import { JManErrorDatabaseNotReady } from '@/assets/js/JMan/JManError'
import { Entity } from '@/assets/js/JMan/Entity'
import { jman } from '@/services/jman'

function replaceOrAddEntity (entities, newEntity, oldEntity) {
	let i = -1;
	if (oldEntity) {
		i = entities.findIndex(e => e == oldEntity);
	} else {
		i = entities.findIndex(e => e.id == newEntity.id);
	}

	if (i != -1 && i !== undefined) {
		entities.splice(i, 1, newEntity);
	} else {
		entities.push(newEntity);
	}

	return entities;
}


export default {

	state: {
		focusedEntity: null,
		entities: [],
		error: null,
		refreshFrequency: 10000,
		lastUpdate: "",
		taskId: null

	},

	mutations: {

		setFocusedEntity (state, entity) {
			state.focusedEntity = entity;
		},

		setEntities (state, entities) {
			state.entities = entities;
		},

		replaceOrAddEntity (state, [newEntity, oldEntity]) {
			replaceOrAddEntity(state.entities, newEntity, oldEntity);
		},

		setError (state, error) {
			state.error = error;
		},

		setFrequency (state, frequency) {
			state.refreshFrequency = Math.max(frequency, 1000);
		},

		setLastUpdate (state, tstamp) {
			state.lastUpdate = tstamp;
		},

		setTaskId (state, taskId) {
			state.taskId = taskId;
		}

	},

	actions: {

		async readFromDB ({state, commit}, options = {}) {
			let lastModified = state.lastUpdate;

			if (!options.hasOwnProperty("lastModified")) {
				options.lastModified = state.lastUpdate;
			}

			const values = await jman.cache.values();
			let entities = [...state.entities];
			for (const value of values) {

				let entity = Entity.make(value, jman);
				await entity.expandUUID();

				replaceOrAddEntity(entities, entity);

				lastModified = value.updatedOn > lastModified
					? value.updatedOn
					: lastModified;
			}

			commit('setEntities', entities);
			commit('setLastUpdate', lastModified);
		},

		async startRefresh ({state, commit, dispatch}, options = {}) {
			if (options.frequency) {
				commit('setFrequency', frequency);
			}

			if (state.taskId) {
				await dispatch('stopRefresh');
			}

			const taskId = setInterval( async () => {
				dispatch('readFromDB', options);
			}, state.refreshFrequency);

			commit('setTaskId', taskId);
		},

		async stopRefresh ({state, commit}) {
			if (state.taskId) {
				clearInterval(state.taskId);
				commit('setTaskId', null);
			}
		},

// 		async fetchEntity ({state, commit, dispatch}, [uuid, opId]) {
// 			try {
// 				const entity = await jman.entityByUuid(uuid);
// 				await entity.expandUUID();
// 				commit('setFocusedEntity', entity);
// 			} catch (err) {
// 				if (err instanceof JManErrorDatabaseNotReady) {
// 					if (! (state.error instanceof JManErrorDatabaseNotReady)) {
// 						// Retry once if waiting for database
// 						commit('setError', err);
// 						setTimeout( async () => {
// 							await dispatch('fetchEntity', uuid);
// 							commit('setError', null);
// 						}, 2000);
// 					}
// 				}
// 			}
// 		},
//
// 		async fetchEntities ({commit, dispatch}, [query = {}, opId]) {
// 			commit('operationStart', opId);
// // 			commit('setEntities', null);
// 			const entities = await jman.entities(query);
//
// 			for (const entity of entities) {
// 				await entity.expandUUID();
// 				await jman.cache.add(entity);
// 			}
//
// // 			commit('setEntities', entities);
// 			commit('operationEnd', opId);
// // 			dispatch('expandEntities');
// 		},
//
// 		async expandEntities ({state, commit}) {
// 			for (let entity of state.entities) {
// 				let newEntity = Entity.make(JSON.parse(JSON.stringify(entity)), jman);
// 				await newEntity.expandUUID();
// 				commit('replaceEntity', [entity, newEntity]);
// 			}
// 		},
	},

	namespaced: true
};



// WEBPACK FOOTER //
// ./src/store/modules/jman.js